import React, { memo } from 'react'
import { GroupProps } from '.'
import { GroupHeader } from '../GroupHeader'
import { URTrainingResultFromServer } from '../../App'
import { Translate, useTranslations } from '../../TranslationsContext'

export const TrainingGrid: React.FC<GroupProps> = memo(
  ({ group, totalGroups, isInlineLoading, onSeeMore, fetchNextPage, children }) => {
    const { outOf, result, results } = useTranslations()

    return (
      <div key={group.title} style={{ paddingBottom: '24px' }}>
        {totalGroups > 1 ? (
          <GroupHeader
            title={group.title}
            pagination={`${group.results.length} ${outOf} ${group.total} ${group.total === 0 ? result : results}`}
            onSeeMore={group.total <= group.results.length ? undefined : () => onSeeMore(group.filter.value)}
          />
        ) : children !== false ? (
          <div>&nbsp;</div>
        ) : (
          <></>
        )}

        <div className="grid-row">
          {group.results
            .map((x) => x as URTrainingResultFromServer)
            .map((article, i) => {
              return <Result key={i} result={article} />
            })}
        </div>

        {isInlineLoading && (
          <div>
            <h3 className="grid-text-center dots grid-gap3-above grid-gap3-below">
              <Translate id="loading" />
              <span>.</span>
              <span>.</span>
              <span>.</span>
              <p></p>
            </h3>
          </div>
        )}
      </div>
    )
  }
)

const Result: React.FC<{ result: URTrainingResultFromServer }> = memo(({ result }) => {
  return (
    <div className="grid-span4 grid-omega3 grid-tablet-span6 grid-tablet-omega2 grid-mobile-span12 grid-mobile-omega1">
      <a className="eventitem" href={result.url}>
        <div className="eventitem-image eventitem-image--wide">
          <img src={result.image} alt="" />
          <span className={`eventitem-image--label eventitem-image--label-${result.typeColor}`}>{result.typeText}</span>
        </div>

        <div className="eventitem-content">
          <div className="eventitem-title-wrapper">
            <span className="eventitem-title">{result.name}</span>
          </div>
          <span className="eventitem-subtitle">
            <Translate id="whenAndWhere" />
          </span>
          {result.dateText}
          <br />
          <div dangerouslySetInnerHTML={{ __html: result.locationText }}></div>
          <br />
          <span className="eventitem-subtitle">
            <Translate id="language" />
          </span>
          {result.languages}
          <br />
          <br />
          <span
            className={`available-seats ${
              result.availableSeats >= 0 && result.availableSeats <= 3 ? 'eventitem-highlight' : ''
            }`}
          >
            {result.availableSeatsText}
          </span>
        </div>
      </a>
    </div>
  )
})
